var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 11.0001H21.0001M15.5001 11.0001V7.00012M15.5001 11.0001H8.75008M3.00008 11.0001H8.75008M8.75008 11.0001V7.00012M6.25008 17.0001H3.00008L3.00002 9.00003C3.00001 7.89545 3.89545 7.00001 5.00003 7.00001L19.0001 7.00011C20.1047 7.00011 21.0001 7.89554 21.0001 9.00011V17.0001H17.7501M8.75008 17.0001H15.2501M9.00008 17.5001C9.00008 18.3285 8.32851 19.0001 7.50008 19.0001C6.67166 19.0001 6.00008 18.3285 6.00008 17.5001C6.00008 16.6717 6.67166 16.0001 7.50008 16.0001C8.32851 16.0001 9.00008 16.6717 9.00008 17.5001ZM18.0001 17.5001C18.0001 18.3285 17.3285 19.0001 16.5001 19.0001C15.6717 19.0001 15.0001 18.3285 15.0001 17.5001C15.0001 16.6717 15.6717 16.0001 16.5001 16.0001C17.3285 16.0001 18.0001 16.6717 18.0001 17.5001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.5723841c55454f6bb8052a9bd0244090.svg";
export { ForwardRef as ReactComponent };